import {useHistory} from "react-router-dom";
import Axios from "axios";
import {useContext} from "react";
import FixelDataContext from "../context/FixelDataContext";

const useAxios = () => {
    const history = useHistory();
    const { showSpinner, setShowSpinner } = useContext(FixelDataContext);

    return async (method, url, data) => {
        try {
            setShowSpinner(true);
            const res = await Axios[method](url, data);
            setShowSpinner(false);

            return res;
        } catch (error) {
            if (showSpinner) {
                setShowSpinner(false);
            }
            console.error(
                "TCL ~ file: useAxios.js ~ sendAxiosRequest ~ error",
                "method:",
                method,
                "url:",
                url,
                error.message,
                error.toJSON(),
            );
            history.push("/errorPage");
        }
    };
};
export default useAxios;
